module.exports = __webpack_public_path__ + "img/arr-p-down.da197c31.svg";